<template>
  <div style="background:#fff">
    <header class="aui-navBar aui-navBar-fixed b-line">
      <a @click="returnPage" class="aui-navBar-item">
        <i class="icon icon-return"></i>
      </a>
      <div class="aui-center">
        <span class="aui-center-title">充值记录</span>
      </div>
      <a @click="returnHome" class="aui-navBar-item">
        <i class="icon icon-sys"></i>
      </a>
    </header>
    <section class="aui-scrollView no-foot">
      <ul class="pay-list">
        <li v-for="(item,index) in list" :key="index">
          <div class="l">
            <template v-if="item.purpose == 'coin'">
               <strong>阅读币充值</strong>
                <span>{{item.payAmount/100}}元</span>
            </template>
            <template v-if="item.purpose == 'vip'">
               <strong>VIP充值</strong>
                 <span>{{item.payAmount/100}}元</span>
            </template>
          </div>
          <div class="r">
            <strong class="c-green">
              <template v-if="item.purpose == 'coin'">
                  +{{item.addCount}}书币
              </template>
              <template v-else>
                 +{{item.addCount}}天
              </template>
            </strong>
            <span>{{item.gmtFinish}}</span>
          </div>
        </li>
      </ul>

      <div class="ls-t-c">没有充值记录</div>
    </section>
    <!-- <div class="topbar flex">
      <div class="fl">
        <a @click="returnPage">
          <i class="fa-angle-left"></i>
        </a>
      </div>
      <div class="span-title">消费记录</div>
      <a class="lk-home" @click="returnHome">
        <i class="fa-home"></i>
      </a>
    </div>-->

    <!-- <div v-if="hasData" class="mt25">
      <ul class="records-list">
        <li class="list-title"><span>2019-09</span></li>
        <li class="list-item">
          <div class="list-item-l">
            周五<br/>09-20
          </div>
          <div class="list-item-r">
            <div>
              <p class="f14">
                名侦探柯南
                <span class="p-blue">-60金币</span>
              </p>
              <p class="f12">第16章</p>
            </div>
          </div>
        </li>
        <li class="list-item">
          <div class="list-item-l">
            周五<br/>09-20
          </div>
          <div class="list-item-r">
            <div>
              <p class="f14">
                名侦探柯南
                <span class="p-blue">-60金币</span>
              </p>
              <p class="f12">第17章</p>
            </div>
          </div>
        </li>
        <li class="list-item">
          <div class="list-item-l">
            周五<br/>09-20
          </div>
          <div class="list-item-r">
            <div>
              <p class="f14">
                名侦探柯南
                <span class="p-blue">-60金币</span>
              </p>
              <p class="f12">第18章</p>
            </div>
          </div>
        </li>

        <li class="list-title"><span>2019-08</span></li>
        <li class="list-item">
          <div class="list-item-l">
            周五<br/>09-20
          </div>
          <div class="list-item-r">
            <div>
              <p class="f14">
                名侦探柯南
                <span class="p-blue">-60金币</span>
              </p>
              <p class="f12">第16章</p>
            </div>
          </div>
        </li>
        <li class="list-item">
          <div class="list-item-l">
            周五<br/>09-20
          </div>
          <div class="list-item-r">
            <div>
              <p class="f14">
                名侦探柯南
                <span class="p-blue">-60金币</span>
              </p>
              <p class="f12">第17章</p>
            </div>
          </div>
        </li>
        <li class="list-item">
          <div class="list-item-l">
            周五<br/>09-20
          </div>
          <div class="list-item-r">
            <div>
              <p class="f14">
                名侦探柯南
                <span class="p-blue">-60金币</span>
              </p>
              <p class="f12">第18章</p>
            </div>
          </div>
        </li>

      </ul>
    </div>

    <div v-else class="mt25">
      <div class="h400">
        <div class="no_book">
          <p>暂时没有记录</p>
        </div>
      </div>
    </div>-->
  </div>
</template>

<script>
import userService from '../../../services/userService'
export default {
  name: 'purchase-list',
  data () {
    return {
      loading: false,
      finished: false,
      list: [],
      currentPage: 1
    }
  },
  methods: {
    returnPage () {
      this.$router.isBack = true
      this.$router.go(-1)
    },
    returnHome () {
      this.$router.isBack = false
      this.$router.push('/home')
    },
    getList () {
      userService.rechargeRecords().then(res => {
        const resData = res.data
        if (res.result) {
          this.list = resData.items || []
        }
      })
    }
  },
  created () {
    this.getList()
    this.$router.isBack = true
  }
}
</script>

<style scoped>
</style>
